export default "/images/vendor/flag-icons/flags/4x3/dj.svg?ea8afc9d1db6e4acd7bb849832185ee9";